var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPrestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46855",
    "data-name": "Group 46855",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2292",
    "data-name": "Line 2292",
    x1: 10,
    transform: "translate(0 10)",
    fill: "none",
    stroke: "#2b2d2f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2293",
    "data-name": "Line 2293",
    y2: 8,
    transform: "translate(5)",
    fill: "none",
    stroke: "#2b2d2f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2294",
    "data-name": "Line 2294",
    x1: 4,
    y2: 4,
    transform: "translate(5 4)",
    fill: "none",
    stroke: "#2b2d2f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2295",
    "data-name": "Line 2295",
    x2: 4,
    y2: 4,
    transform: "translate(1 4)",
    fill: "none",
    stroke: "#2b2d2f",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPrestart);
export default __webpack_public_path__ + "static/media/download-prestart.5309c81dfbfc3729293a0d7b04e72c74.svg";
export { ForwardRef as ReactComponent };